import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type TabGroupStateType = Readonly<{
    isRecentlyViewedTabVisible: boolean;
    isRelatedProductsTabVisible: boolean;
    isComponentsTabVisible: boolean;
    isTopSellerTabVisible: boolean;
    currentTab: string;
}>;

const initialCounterState: TabGroupStateType = {
    isRecentlyViewedTabVisible: true,
    isRelatedProductsTabVisible: true,
    isComponentsTabVisible: true,
    isTopSellerTabVisible: true,
    currentTab: "",
};

const productCarouselTabsReducer = createTypedReducerWithImmer(initialCounterState, {
    "Custom/CarouselTab/RecentlyViewedTabVisible": (
        draft: Draft<TabGroupStateType>,
        action: { isRecentlyViewedTabVisible: boolean },
    ) => {
        draft.isRecentlyViewedTabVisible = action.isRecentlyViewedTabVisible;
    },
    "Custom/CarouselTab/ComponentsTabVisible": (
        draft: Draft<TabGroupStateType>,
        action: { isComponentsTabVisible: boolean },
    ) => {
        draft.isComponentsTabVisible = action.isComponentsTabVisible;
    },
    "Custom/CarouselTab/RelatedProductsTabVisible": (
        draft: Draft<TabGroupStateType>,
        action: { isRelatedProductsTabVisible: boolean },
    ) => {
        draft.isRelatedProductsTabVisible = action.isRelatedProductsTabVisible;
    },
    "Custom/CarouselTab/TopSellerTabVisible": (
        draft: Draft<TabGroupStateType>,
        action: { isTopSellerTabVisible: boolean },
    ) => {
        draft.isTopSellerTabVisible = action.isTopSellerTabVisible;
    },
    "Custom/CarouselTab/CurrentTab": (draft: Draft<TabGroupStateType>, action: { currentTab: string }) => {
        draft.currentTab = action.currentTab;
    },
});

(reducers as any).productCarouselTabsReducer = productCarouselTabsReducer;

export type TabGroupState = {
    productCarouselTabsReducer: TabGroupStateType;
} & ApplicationState;

type Reducers = {
    productCarouselTabsReducer: typeof productCarouselTabsReducer;
};

export type ProductCarouselTabActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
